import react, { useEffect, useState, useContext } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { Row, Col } from "react-bootstrap";
import { Institute, DSRCodes, Society, } from "../../ReusableComponents/NCLAdminDropdowns";
import { useSelector } from "react-redux";
import { AssessmentDates } from "../../ReusableComponents/CommonApis";
import axiosInstance from "../../ReusableComponents/Axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
const EmailDeliveryStatus = () => {
    const { SetLoad } = useContext(LoadContext);
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
    const [SelectINID, SetSelectINID] = useState();
    const [SocietyId, SetSocietyId] = useState("0");
    const [ListData, SetListData] = useState([]);
    const HandleInstituteChange = (e) => {
        SetSelectINID(e);
        // SetSRSData("0");
        SetSocietyId("0");
    };

    const GetEmailDeliveryStatus = async () => {
        SetLoad(true);
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetEmailDeliveryStatus?InstituteID=${SelectINID?.Value}&Academicyear=${USYear?.value}&ContestcreationId=${SelectDate?.contestCreationId}&AssessmentType=${SelectDate?.assessmentType}&AssessmentTypeNo=${SelectDate?.assessmentTypeNo}`);
            SetListData(res.data);
            SetLoad(false);
        }
        catch (err) {
            SetLoad(false);
            console.log("Error in GetEmailDeliveryStatus", err);
        }
    }

    useEffect(() => { if (SelectINID?.Value && SelectDate?.contestCreationId) GetEmailDeliveryStatus() }, [SelectINID, SelectDate])
    const Columns = [
        { name: "Assessment Name", selector: "assessmentName", sortable: false },
        { name: "School Id", selector: "schoolId", sortable: false },
        { name: "School Name", selector: "schoolName", sortable: true },
        { name: "Email", selector: "schoolEmail", sortable: true },
        { name: "Delivery Status", selector: "deliveryStatus", sortable: true },
        { name: "Sent Date", selector: "sentDate", sortable: true },
    ];
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="MainHeading mt-2 mb-2">Email Delivery Status</div>
                <div className="InputFIlters">
                    <label>Report Input</label>
                    <br />
                    <Row>
                        <Col>
                            <Institute className="NCLDropdown w-100" StoreValue={SetSelectINID} SOption={SelectINID?.Value}
                                onChange={(e) => { HandleInstituteChange(e); }} labelname={<div className="DropdownHeader">Institute :</div>} />
                        </Col>

                        {/* {(SelectINID?.Value === 1 || SelectINID?.Value === 3) && (
                      <Col> <DSRCodes className="NCLDropdown w-100" PId={SelectINID?.Value} id="0" StoreValue={SetSRSData}
                          onChange={(e) => { SetSRSData(e); }} labelname={<div className="DropdownHeader">Region :</div>} />
                      </Col> (SelectINID?.Value === 8 || SelectINID?.Value === 9 || SelectINID?.Value === 5)
                    )} */}

                        {[5, 8, 9].includes(SelectINID?.Value) && (
                            <Col>
                                <Society className="NCLDropdown w-100" PId={SelectINID?.Value} id="0" StoreValue={SetSocietyId}
                                    onChange={(e) => { SetSocietyId(e); }} labelname={<div className="DropdownHeader">Society :</div>} />
                            </Col>
                        )}
                        {SelectINID && (
                            <Col className="dflex">
                                <div>
                                    <AssessmentDates InstId={SelectINID?.Value} Society={SocietyId?.value}
                                        labelname={<div className="DropdownHeader">Assessment Date :</div>} />
                                </div>
                                <div className="d-flex align-items-center">
                                    <button onClick={() => GetEmailDeliveryStatus()} className="Buttons m-3" > Go </button>
                                </div>
                            </Col>
                        )}
                        <Col></Col>
                        {/* <Col>
                            <div className="d-flex align-items-center">
                                <button onClick={() => GetEmailDeliveryStatus()} className="Buttons m-3" > Go </button>
                            </div>
                        </Col> */}
                    </Row>
                </div>
                <DataTable className="NCLDataTable Card mt-3" data={ListData} columns={Columns}
                    Dropdownvalues={["10", "25", "50", "100"]} ShowPagination={true} ShowPagecount={true} />
            </div>
        </>
    )
}
export default EmailDeliveryStatus;